export default __webpack_public_path__ + "static/media/3.245ffdb7.jpg";